import BaseReport from '@/store/modules/BaseReport'

export default class Certificates extends BaseReport {
    constructor() {
        const reportUrl = '/backend/certificates/'
        super(reportUrl)

        this.actions.getOne = async function (ctx, id) {
            const url = `${reportUrl}${id}/`
            const method = 'get'
            return await BaseReport.makeRequest({method, url})
        }
    }
}
